import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ProfileComponent } from './profile.component';
import { ProfileResolver } from './profile-resolver.service';
import { SharedModule } from '../shared';
import { ProfileRoutingModule } from './profile-routing.module';
import {StatisticsModule} from '../shared/layout/statistics.module';
import {SharedModule as SharedNgModule} from 'primeng/api';
import {CategoryModule} from '../shared/layout/category.module';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {NotificationModule} from '../shared/layout/notification.module';
import {FileUploadModule} from 'primeng/fileupload';

@NgModule({
    imports: [
        SharedModule,
        ProfileRoutingModule,
        StatisticsModule,
        CategoryModule,
        SharedModule,
        SharedNgModule,
        InputTextModule,
        ButtonModule,
        ToastModule,
        ConfirmDialogModule,
        NotificationModule,
        FileUploadModule
    ],
  declarations: [
    ProfileComponent
  ],
  providers: [
    ProfileResolver
  ]
})
export class ProfileModule {}
